// src/components/AMain/SaverCreditTwoUp.js
import React from "react";
import { useNavigate } from "react-router-dom";

import SaverCreditGrid from "../Page1Main/SaverCreditGrid";
import SaversQuickGate from "../Page1Main/SaversQuickGate";
import Mini from "../Comms/MiniSaver";

import "./SaverCreditTwoUp.css";

export default function SaverCreditTwoUp() {
  const navigate = useNavigate();

  const gotoSavers = () => {
    window.scrollTo(0, 0);
    navigate("/1"); // change to your route
  };

  return (
    <div className="two-up-wrapper">
      <div className="two-up-item">
        <div className="two-up-inner">
          <SaversQuickGate />
        </div>
      </div>

      <div className="two-up-item">
        <div className="two-up-inner">
          <SaverCreditGrid />

          <section className="sc-hero">
            <div className="sc-hero-box" style ={{marginTop: "20px"}}>
              <Mini />
            </div>
          </section>

          {/* Optional CTA if you want it */}
          {/* <button className="two-up-cta" type="button" onClick={gotoSavers}>
            Go to Saver’s module →
          </button> */}
        </div>
      </div>
    </div>
  );
}
